<template>
   <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="grid grid-cols-12 gap-x-4">

             <!-- Start User By Device Section -->
             <div class="col-span-full lg:col-span-12 card">
                <div class="flex-center-between">
                    <h6 class="card-title text-lg leading-none">Accounting Overview</h6>
                    <div class="leading-none shrink-0 text-xs text-gray-500 dark:text-dark-text dk-border-one rounded-full px-2 py-1 dk-theme-card-square">All Time</div>
                </div>
                <div class="flex flex-col h-full">
                    <div id="analytic-device-session-chart" class="flex-center grow"></div>
                    <div class="flex-center-between py-5 gap-4">
                        <div >
                             <router-link :to="'/saleview'" >
                            <div class="card-title text-danger"> Sale</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(sale)?parseInt(sale):0}}</div>
                            </router-link>
                        </div>
                        <div>
                             <router-link :to="'/purchaseview'" >
                            <div class="card-title text-success"> Purchase</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(purchase)?parseInt(purchase):0}}</div>
                             </router-link>
                        </div>
                        <div>
                            <router-link :to="'/salelist'" >
                            <div class="card-title text-base text-danger"> Sale Due</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(saleDue)?parseInt(saleDue):0}}</div>
                            </router-link>
                        </div>
                        <div>
                              <router-link :to="'/purchaselist'" >
                            <div class="card-title text-base text-success">Purchase Due</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{(purDue)?parseInt(purDue):0}}</div>
                              </router-link>
                        </div>
                        <div>
                             <router-link :to="'/accountReport'" >
                            <div class="card-title text-base text-info"> Stock Value</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{(stock)?parseInt(stock):0}}</div>
                             </router-link>
                        </div>


                        </div>
                        
                        
                        <div class="flex-center-between py-5 gap-4">
                        <div class="card card-body">
                             <router-link :to="'/saleview'" >
                            <div class="card-title text-danger"> Today Sale</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(today)?parseInt(today?.sale || 0):0}}</div>
                            </router-link>
                        </div>
                        <div>
                             <router-link :to="'/purchaseview'" >
                            <div class="card-title text-success"> Sale QTY</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(today)?parseInt(today?.sale_qty || 0):0}}</div>
                             </router-link>
                        </div>
                        <div>
                            <router-link :to="'/salelist'" >
                            <div class="card-title text-base text-danger"> Today Purchase</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(today)?parseInt(today?.purchase || 0):0}}</div>
                            </router-link>
                        </div>
                        <div>
                              <router-link :to="'/purchaselist'" >
                            <div class="card-title text-base text-success">Purchase QTY</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{(today)?parseInt(today?.purchase_qty || 0):0}}</div>
                              </router-link>
                        </div>
                        

                        </div>


                    
                          <div class="flex flex-col h-full">
                                <div id="analytic-device-session-chart" class="flex-center grow"></div>
                                    <div class="flex-center-between py-5">

                            <div>
                            <router-link :to="`/delievryReport?q=11`" >
                            
                                <div class="card-title text-base text-danger" > Pending Order</div>
                                <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{(pendingorder)?pendingorder:0}}</div>
                                    </router-link>
                            </div>
                  


                                <div>
                                <router-link :to="`/delievryReport?q=1`" >
                                
                                    <div class="card-title text-base text-info"> Processing Order</div>
                                    <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{(processingorder)?processingorder:0}}</div>
                                    </router-link>
                                </div>

                              <div>
                                <router-link :to="`/delievryReport?q=2`">
                                
                                    <div class="card-title text-base text-success"> Complete Order</div>
                                    <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{(completeorder)?completeorder:0}}</div>
                                    </router-link>
                                </div>






                    </div>
                    </div>







                </div>
            </div>
            <!-- End User By Device Section -->

         <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        
                    <div class="flex-center-between">
                        <h6 class="card-title text-lg leading-none">Delivery Order Review</h6>
                        <div class="leading-none shrink-0 text-xs text-gray-500 dark:text-dark-text dk-border-one rounded-full px-2 py-1 dk-theme-card-square">All Time</div>
                    </div>
                    
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">ID</th>
                                    <th class="bg-[#B2E8D9]">Bill No</th>
                                    <th class="bg-[#B2E8D9]">Bill Date</th>
                                    <th class="bg-[#B2E8D9]">Delv. Date</th>
                                    <th class="bg-[#B2E8D9]">Customer Name</th>
                                    <th class="bg-[#B2E8D9]">Products</th> 
                                    <th class="bg-[#B2E8D9]">Status</th> 
                                    <th class="bg-[#B2E8D9]">Tailor Name</th> 
                                    <th class="bg-[#B2E8D9]">Processing<br>Date</th>
                                    <th class="bg-[#B2E8D9]">Complete<br>Date</th>  
                                    <th class="bg-[#B2E8D9]">Total</th>  
                                    <th class="bg-[#B2E8D9]">View</th> 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in delivList" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.saleid}}</td>
                                    <td>{{item.entrydate}}</td>
                                    <td>{{item.deliverydate === '0000-00-00' ? '--' : item.deliverydate}}</td>
                                    <td>{{item.customer_name}}</td>
                                    <td>{{item.prd}}({{item.pieceqty}})</td> 
                                    <td>{{item.status_txt}}</td>
                                    <td>{{ item.tailor_name ? item.tailor_name : 'No tailor assigned' }}</td>
                                    <td>{{ item.processing_date === '0000-00-00 00:00:00' ? '--' : item.processing_date }}</td>
                                    <td>{{ item.complete_date === '0000-00-00 00:00:00' ? '--' : item.complete_date }}</td>
                                    <td>{{ item.qty * item.rate }}</td>
                                     <td>
                                            <div class="flex items-center gap-1">
                                             <button class="btn-icon btn-primary-icon-light size-7" @click="print_invoice(item.saleid)" >
                                                   <i class="ri-printer-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                </button> 
                                            </div>
                                    </td> 
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
           
  
            <!-- End Chat Inbox -->


<!--  start today birthday -->

     <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        
                    <div class="flex-center-between">
                        <h6 class="card-title text-lg leading-none">Today Customer Birthday</h6>
                        <div class="leading-none shrink-0 text-xs text-gray-500 dark:text-dark-text dk-border-one rounded-full px-2 py-1 dk-theme-card-square">All Time</div>
                    </div>
                    
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">SR</th>
                                    <th class="bg-[#B2E8D9]">Name</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                          
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in custbirthdayList" :key="item.id">
                                    <td>{{index+1}}</td>
                                    <td>{{item.name}}</td>
                                    <td>{{item.dob}}</td> 
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>

 <!--  end today birthday -->




        </div>
    </div>
</template>

<script>
// @ is an alias to /src 
import axios from 'axios';

export default {
  name: 'HomeView', 
mounted(){
 this.getBasics();
}, 
data() {
 return {
        today:[],
        sale:0,
        purchase:0,
        saleDue:0,
        purDue:0,
        stock:0, 
        delivList:[],
        pendingorder:[],
        processingorder:[],
        completeorder:[],
        custbirthdayList:[],
 }
 }, 
  methods:{
print_invoice(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/thermalPrint?q='+id, '_blank'); 
        },
 async getBasics() {
       var self=this;
         axios.post('getDashboard').then(function (response) {
                 self.sale=response.data.sale;
                 self.today=response.data.today;
                 self.purchase=response.data.purchase;
                 self.saleDue=response.data.saleDue;
                 self.purDue=response.data.purDue;
                 self.stock=response.data.stock;
                 self.delivList=response.data.delivList;
                 self.pendingorder=response.data.pendingorder;
                 self.processingorder=response.data.processingorder;
                 self.completeorder=response.data.completeorder;
                 self.custbirthdayList=response.data.custbirthdayList;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            "order": [] 
                         });
              
                    });;;
  }, 
  }
}
</script>
